import React from 'react'
import { authPredicate } from '../stores/mainStore'
import { Route, Redirect } from 'react-router-dom'

const RedirectIfAuth = ({ component: Component, ...rest }) => (
  <Route {...rest} render={redirectIfAuth(authPredicate)(Component)} />
)

export const redirectIfAuth = (authPredicate) => (Component) => (props) =>
  authPredicate() ? (
    <Redirect
      to={{
        pathname: '/',
        state: { from: props.location },
      }}
      {...props}
    />
  ) : (
    <Component {...props} />
  )

export default RedirectIfAuth
